var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M17.7187 15.1799C16.8631 15.1796 16.0414 15.5147 15.4298 16.1132L9.46874 12.7616C9.59123 12.2561 9.59123 11.7287 9.46874 11.2232L15.428 7.87161C15.9847 8.41314 16.716 8.73884 17.4909 8.79039C18.2659 8.84195 19.0339 8.616 19.6574 8.15299C20.281 7.68998 20.7194 7.02015 20.8941 6.26341C21.0689 5.50667 20.9686 4.71243 20.6112 4.02289C20.2538 3.33334 19.6627 2.79351 18.9436 2.50004C18.2245 2.20657 17.4245 2.17862 16.6867 2.42119C15.9489 2.66376 15.3215 3.16102 14.9169 3.82395C14.5122 4.48687 14.3567 5.27217 14.4783 6.03926L8.37843 9.47051C7.8993 9.07132 7.31634 8.81694 6.69784 8.73716C6.07933 8.65738 5.4509 8.75551 4.88617 9.02005C4.32143 9.2846 3.84377 9.7046 3.50916 10.2309C3.17454 10.7571 2.99683 11.3678 2.99683 11.9914C2.99683 12.6151 3.17454 13.2258 3.50916 13.752C3.84377 14.2783 4.32143 14.6983 4.88617 14.9628C5.4509 15.2274 6.07933 15.3255 6.69784 15.2457C7.31634 15.166 7.8993 14.9116 8.37843 14.5124L14.4783 17.9455C14.3728 18.6082 14.4731 19.2873 14.7656 19.8913C15.058 20.4952 15.5286 20.995 16.1139 21.3232C16.6992 21.6513 17.3711 21.7922 18.0389 21.7267C18.7067 21.6613 19.3385 21.3926 19.8489 20.957C20.3593 20.5214 20.7239 19.9397 20.8935 19.2905C21.0631 18.6412 21.0295 17.9556 20.7974 17.326C20.5652 16.6964 20.1456 16.1531 19.5952 15.7694C19.0447 15.3856 18.3898 15.1799 17.7187 15.1799Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }